import { EntityRequestRemote } from "../../entity/EntityRequestRemote";

export class DtoRequestRemotesPutRes extends EntityRequestRemote {}
